import { c as _c } from "react/compiler-runtime";
import { Banner } from '../../Banner/Banner';
type Props = {
  className?: string;
};
export function BannerNoJavaScript(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>Hinweis: Um alle Funktionen unserer Seiten nutzen zu können, wird JavaScript empfohlen.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <noscript><Banner className={className}>{t1}</Banner></noscript>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}